import {
    createContext,
    PropsWithChildren,
    useState, 
    useContext,
    useEffect,
    useRef
} from "react"
import { TicketConfigContextValue } from "./types"
import { initialTicketConfigContextValue } from "./utils"
import { useTicketsConfig } from "@hooks/use-config/ticket"
import { getTableColumnsFromFields } from "@hooks/use-config/ticket/utils"

const TicketConfigContext = createContext<TicketConfigContextValue>({} as any)

export const TicketConfigContextProvider = ({ children } : PropsWithChildren) => {
    const [state, setState] = useState<TicketConfigContextValue>(
        initialTicketConfigContextValue
    );

    const { getConfig } = useTicketsConfig();

    const hasFetchedConfig = useRef(false);
    useEffect(() => {
        const getInitialConfig = async () => {
                const config = await getConfig();
                setState({
                    loading: false,
                    error: null,
                    config: config ?? ({} as TicketConfigContextValue["config"]),
                    tableColumns: getTableColumnsFromFields(config ?? {})
                });     
            };
        if (!hasFetchedConfig.current) {
            hasFetchedConfig.current = true;
            getInitialConfig();
        }
    }, [getConfig]);

    return (
        <TicketConfigContext.Provider value={state}>
            {children}
        </TicketConfigContext.Provider>
    )
}

export const useTicketConfigContext = () => {
    const context = useContext(TicketConfigContext);
    if (!context) {
        throw new Error("useTicketConfigContext must be used within a TicketConfigContextProvider");
    }
    return context;
}